<template>
	<v-card>
		<v-card-title>Pendientes de Asignar</v-card-title>
		<v-data-table
			:headers="encabezados"
			:items="pacientes"
			:items-per-page="5"
			class="elevation-1"
			:multi-sort="true"
			@click:row="filaSeleccionada"
		></v-data-table>
	</v-card>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi.js'
export default {
	name: 'PacientesPendientes',
	data: () => ({
		encabezados: [
			{text: 'Folio', value: 'id'},
			{text: 'Fecha', value: 'fecha'},
			{text: 'Módulo o Programa', value: 'moduloPrograma'},
			{text: 'Nombre del Paciente', value: 'nombre'},
			{text: 'Edad', value: 'edad'},
		],
		pacientes: [],
	}),
	mounted: function(){
		ServiciosApi.pacientesPendientes()
			.then(response => {
				this.respuesta = response.data
				if(this.respuesta.status === 'ok'){
					this.pacientes = this.respuesta.datos
				}
			})
			.catch(error => {
				console.log("Hubieron errores", error.response)
			})
	},
	methods: {
		filaSeleccionada(event) {
			const solicitud = {
				idSolicitud: event.id,
				nombre: event.nombre,
				fechaSolicitud: event.fecha,
			}
			this.$emit('solicitud-seleccionada', solicitud)
			console.log("Solicitud", solicitud)
		}
	}
}
</script>
